// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1NUCo","vLegacy":"SelectSecondary_vLegacy__1sfUS","error":"SelectSecondary_error__1wUjY","disabled":"SelectSecondary_disabled__1Cgm-"};